import { render } from "./SheZhi.vue?vue&type=template&id=04243d86&scoped=true"
import script from "./SheZhi.vue?vue&type=script&lang=js"
export * from "./SheZhi.vue?vue&type=script&lang=js"

import "./SheZhi.vue?vue&type=style&index=0&id=04243d86&scoped=true&lange=less&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04243d86"]])

export default __exports__